import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const EditspecKey = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Edit Spec Name" }));
  const history = useHistory();
  const [specName, setSpecName] = useState('');
  const [groupID, setgroupID] = useState();
  const [listgroupID, setListgroupID] = useState([]);
  const [displayOrder, setDisplayOrder] = useState(0)


  const AlertError = (message) => {
    Swal.fire("Alert", message, "error");
  };

  const getListGroup = async () => {
    const apiUrls = `${baseURLV1}/specGroup?page=1&limit=10000`;
    let token = localStorage.getItem("Token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        setListgroupID(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };


  useEffect(() => {
    setDisplayOrder(props.location.state.row.ordering)
    setSpecName(props.location.state.row.key);
    setgroupID(String(props.location.state.row.specgroup.id));
    getListGroup()
  }, []);

  const onSubmit = async (data) => {
    if (specName === undefined) {
      return AlertError("Please insert group name !!");
    }

    if (groupID === undefined || groupID === "") {
      return AlertError("Please insert group name !!");
    }


    var events = {
      key: specName,
      specgroup_id: groupID,
      ordering: String(displayOrder)

    };

    let apiUrls = `${baseURLV1}/speckeys/${props.location.state.row.id}`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Alert",
          "Your can not update Spec Name. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Edit Spec Name"></CardHeader>
        <CardBody>
          
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Spec Group Type" })}:{" "}
            </p>
            <select
              as="select"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={groupID}
              onChange={e => setgroupID(e.target.value)}
            >
              <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
              {listgroupID &&
                listgroupID.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.groupname}
                    </option>
                  );
                })}
            </select>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Spec Name" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={specName}
              onChange={(e) => setSpecName(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: '25px' }}>
            <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
              <span style={{ color: "red" }}>
                *
              </span>
              display order
            </p>
            <input
              name="displayOrder"
              type="number"
              style={{
                height: '38px',
                width: '530px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              value={displayOrder}
              onChange={displayOrder => {
                if (displayOrder.target.value >= 0) {
                  setDisplayOrder(displayOrder.target.value)
                }
              }
              }
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/SpecKeyManagement">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
